export default __webpack_public_path__ + "static/media/Music.82abceca.jpg";